<script setup lang="ts">
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <td
        data-slot="table-cell"
        :class="
            cn(
                'py-2.5 align-middle whitespace-nowrap text-slate-500 [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
                props.class,
            )
        "
    >
        <div class="border-r border-gray-200 px-4 text-sm md:text-base">
            <slot />
        </div>
    </td>
</template>
